import { Loader } from "rizzui";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import AgencyIntegrateRepository from "@/utilities/repositories/AgencyIntegrate";
import { useNavigate } from "react-router-dom";
import { routes } from "@/config/routes";
import toast from "react-hot-toast";

export default function GoogleCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const code = searchParams.get("code") || "";
        const scope = searchParams.get("scope") || "";
        await AgencyIntegrateRepository.updateGoogleCallback({
          code,
          scope,
        });
        toast.success("Connected to Google successfully");
        navigate(routes.agency.integrations, {
          replace: true,
        });
      } catch (error) {
        console.log(error);
        navigate(routes.agency.integrations, {
          replace: true,
        });
      }
    })();
  }, [searchParams]);

  return (
    <div className="flex items-center justify-center h-screen">
      <Loader />
    </div>
  );
}
